import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
  Table,
} from 'semantic-ui-react';
import { parseISO } from 'date-fns';
import {
  closeInvoiceVoidLogModal,
  getInvoiceVoidLogsAction,
} from 'state/business/actions';
import { formatLocalDateTime } from 'utils/dateTimeUtils';
import DefaultPagination from 'components/DefaultPagination';

const PAGE_SIZE = 10;

function InvoiceVoidLogModal() {
  const dispatch = useDispatch();
  const open = useSelector(state => state.business.invoiceVoidLogModalOpen);
  const isLoading = useSelector(state => state.business.loadingInvoiceVoidLogs);
  const invoiceVoidLogs = useSelector(state => state.business.invoiceVoidLogs);
  const allBusiness = useSelector(state => state.business.allBusiness);

  const { data, paging } = invoiceVoidLogs || {};
  const page = paging ? paging.page : 1;
  const size = paging ? paging.size : PAGE_SIZE;
  const total = paging ? paging.total : 0;

  const onClose = () => dispatch(closeInvoiceVoidLogModal());

  const onPageChange = newPage => {
    const businessId = allBusiness.data[allBusiness.activeIndex].id;
    dispatch(
      getInvoiceVoidLogsAction({ businessId, page: newPage, size: PAGE_SIZE })
    );
  };

  const formatTime = time => {
    if (!time) return '-';
    return formatLocalDateTime(parseISO(time));
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalHeader>Invoice Void Logs</ModalHeader>
      <ModalContent>
        <Table celled selectable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Time</Table.HeaderCell>
              <Table.HeaderCell>Performed By</Table.HeaderCell>
              <Table.HeaderCell>Invoice Number</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {data && data.length > 0 ? (
              data.map((log, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <Table.Row key={`${log.invoice_number}-${log.time}-${index}`}>
                  <Table.Cell>{formatTime(log.time)}</Table.Cell>
                  <Table.Cell>{log.performed_by || '-'}</Table.Cell>
                  <Table.Cell>{log.invoice_number || '-'}</Table.Cell>
                </Table.Row>
              ))
            ) : (
              <Table.Row>
                <Table.Cell colSpan={3} textAlign="center">
                  No Invoice Void Logs
                </Table.Cell>
              </Table.Row>
            )}
          </Table.Body>
        </Table>
        {!isLoading && total > 0 && (
          <DefaultPagination
            activePage={page}
            totalCount={total}
            pageSize={size}
            onPageChangeV2={onPageChange}
          />
        )}
      </ModalContent>
      <ModalActions>
        <Button onClick={onClose}>Close</Button>
      </ModalActions>
    </Modal>
  );
}

export default InvoiceVoidLogModal;
